// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EzzMGYIrfQMJcbhlD6uB,.jfY059RF0TE5kK0gEmBD,.dFfH76vcTkIGDepgJHw5{width:100%}html[dir] .dFfH76vcTkIGDepgJHw5{padding-top:8px}html[dir] .jfY059RF0TE5kK0gEmBD{padding-top:0}.YtvnX7vDX7MJM97Ge7zL,.YtvnX7vDX7MJM97Ge7zL:hover{color:var(--themeDark)}html[dir=ltr] .fSJmJKUBhtUoFlJY09gX,html[dir=rtl] .fSJmJKUBhtUoFlJY09gX{margin-left:5px;margin-right:5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leftNavSection": "EzzMGYIrfQMJcbhlD6uB",
	"leftNavSectionWithNoSectionHeaders": "jfY059RF0TE5kK0gEmBD",
	"leftNavSectionWithSectionHeaders": "dFfH76vcTkIGDepgJHw5",
	"personAddIcon": "YtvnX7vDX7MJM97Ge7zL",
	"accountWarningIcon": "fSJmJKUBhtUoFlJY09gX"
};
module.exports = ___CSS_LOADER_EXPORT___;
